@let row = creator();
@let progress = row.progress;

<a [routerLink]="reportLink()" [attr.aria-label]="'Open ' + row.name + '’s screening report'"
    class="block rounded-xl border border-border bg-card p-2 shadow-sm transition-all hover:-translate-y-0.5 hover:border-brand-studio hover:shadow-md focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-studio">

    <div class="flex flex-col">
        <div class="w-full flex flex-row items-center justify-between">
            <span class="flex items-center gap-3.5">
                <span class="scr-ring grid size-[50px] shrink-0 place-items-center rounded-full"
                    [style.--ring-pct]="progress.completion" [style.--ring-colour]="ringColour()" aria-hidden="true">
                    <span class="relative font-heading text-[17px] font-extrabold tracking-[-0.03em] text-foreground">
                        {{ progress.completion }}<i class="not-italic text-[10px] font-bold text-muted-foreground">%</i>
                    </span>
                </span>
        
                <span class="min-w-0 flex-1">
                    <span class="block truncate font-heading text-sm font-semibold leading-tight text-foreground">{{ row.name }}</span>
                    @if (handleLine()) {
                    <span class="text-xs text-secondary truncate">{{ handleLine() }}</span>
                    }
                </span>
            </span>

            <scr-verdict-pill [verdict]="progress.verdict" />

        </div>
    </div>

    <span class="mt-2 block h-1.5 overflow-hidden rounded-full bg-muted">
        <span class="block h-full rounded-full" [style.width.%]="progress.completion"
            [style.background]="ringColour()"></span>
    </span>

    <span class="mt-2 grid grid-cols-2 gap-2.5 border-t border-border pt-2">
        <span class="min-w-0">
            <span
                class="block text-xs font-bold uppercase tracking-[0.06em] text-muted-foreground">Evaluated</span>
            <span
                class="mt-0.5 block font-heading text-sm font-extrabold leading-tight tracking-[-0.02em] text-foreground">
                {{ progress.evaluated }}<small class="ml-0.5 font-sans text-xs font-semibold text-muted-foreground"> /
                    {{ progress.total }}</small>
            </span>
        </span>
        <span class="min-w-0">
            <span class="block text-xs font-bold uppercase tracking-[0.06em] text-muted-foreground">Red
                flags</span>
            <span class="mt-0.5 block font-heading text-sm font-extrabold leading-tight tracking-[-0.02em]"
                [class]="progress.flaggedContent > 0 ? 'text-red-500 dark:text-red-400' : 'text-muted-foreground/70'">
                {{ progress.flaggedContent }}
            </span>
        </span>
    </span>

    <span class="mt-2 flex items-center gap-2.5 text-xs text-muted-foreground">
        {{ footerLabel() }}
        <span aria-hidden="true"
            class="ml-auto inline-flex items-center gap-1.5 font-heading text-sm font-bold text-brand-studio-dark dark:text-brand-studio">
            Open report
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
            </svg>
        </span>
    </span>
</a>